import Navbar from "../components/Navbar";
import Main from "../components/Main";
import About from "../components/About";
import MobileAbout from "../components/About/MobileAbout";
import FAQ from "../components/FAQ";
import Roadmap from "../components/Roadmap";
import PoweredBy from "../components/PoweredBy";
import Tokenomics from "../components/Tokenomics";
import HowToBuy from "../components/HowToBuy";
import Footer from "../components/Footer";
import ExchangeInterface from "../components/ExchangeInterface";
import { isMobile } from "../utils/constants";
import { smoothScroller } from "../utils/helpers";

const Home = () => {
  return (
    <div className="w-full h-screen">
      {/* NAVBAR */}
      <Navbar />
      {/*3D SECTION */}
      <main id="main" className="w-full h-full bg-black">
        <div className="w-full h-full">
          {isMobile ? (
            <video
              className="absolute h-full w-full"
              src="/assets/videos/pepemobile.webm"
              autoPlay
              loop
              muted
            />
          ) : (
            <Main />
          )}
          <a
            href="#buy"
            onClick={smoothScroller}
            className=" w-auto px-2 py-2 items-center text-neutra-200 rounded-md shadow-2xl font-semibold absolute z-[9999] bottom-[5%] sm:button-[8%] left-[40%] md:left-[45%] lg:hidden bg-gradient-to-r from-lime-400 via-green-400 to-green-500 hover:scale-105"
          >
            BUY NOW
          </a>

          <ExchangeInterface className="hidden lg:block w-[26vw] lg:w-[38vw] xl:w-[28vw] relative z-[150] -top-[90%] -right-[48%] md:-right-[38%] lg:-right-[60%] xl:-right-[68%]" />
        </div>
      </main>

      <section
        id="buy"
        className="lg:hidden w-full h-auto bg-black p-4 flex items-center justify-center "
      >
        <ExchangeInterface className="relative rounded-lg sm:w-[60vw]" />
      </section>
      {/* HOWT TO BUY */}
      <section
        id="howtobuy"
        className="w-full h-auto sm:h-full relative p-2 sm:p-0"
      >
        <div
          style={{ backgroundImage: `url(/assets/images/pepe12.jpg)` }}
          className="absolute blur-sm w-[100%] h-[100%] bg-cover bg-fixed"
        ></div>
        <HowToBuy />
      </section>
      {/* ABOUT */}

      <section id="about" className="w-full h-full hidden sm:block">
        <About />
      </section>

      <section
        style={{ backgroundImage: `url(/assets/images/backgroundmatrix.jpeg)` }}
        id="about"
        className="w-full h-full sm:hidden bg-cover bg-fixed "
      >
        <MobileAbout />
      </section>

      <section className="relative">
        <div
          style={{ backgroundImage: `url(/assets/images/pepe9.jpg)` }}
          className="absolute w-[100%] h-[100%] bg-cover bg-fixed contrast-125"
        ></div>
        {/* ROADMAP */}
        <section
          id="roadmap"
          className="w-full h-[150vh] flex flex-col justify-center items-center p-8"
        >
          <h1 className="text-slate-100 font-bold text-4xl md:text-6xl uppercase tracking-wider mt-4 relative">
            roadmap
          </h1>
          <Roadmap />
        </section>
        {/* POWERED BY */}
        <section id="poweredby" className="w-full h-full">
          <PoweredBy />
        </section>
      </section>
      {/* TOKENOMICS */}
      <section id="tokenomics" className="w-full h-[110vh] relative">
        <div
          style={{ backgroundImage: `url(/assets/images/pepe1.jpg)` }}
          className="absolute w-[100%] h-[100%] bg-cover bg-fixed contrast-125"
        ></div>
        <Tokenomics />
      </section>

      {/* FAQ */}
      <section
        id="faq"
        className="w-full h-full flex flex-col bg-black items-center justify-evenly bg-cover bg-center bg-fixed"
        style={{ backgroundImage: `url(/assets/images/pepe13.jpg)` }}
      >
        <span className="text-3xl md:text-5xl text-center font-bold text-slate-100 tracking-wider ">
          FREQUENTLY ASKED QUESTIONS
        </span>
        <FAQ />
      </section>
      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default Home;
